module.exports = __webpack_public_path__ + "img/banner_2.baeb15a8.jpg";